<template>
    <IndexModelLayout

        :modelNamePlural="__('admin::time_entries.time_entries')"
    >

        <Table
            :headings="[
                __('admin::labels.date'),
                __('admin::labels.week_day'),
                __('admin::labels.checked_in_at'),
                __('admin::labels.checked_out_at'),
                __('admin::labels.work_time'),
                __('admin::labels.notes'),
            ]"
            :with-filters="true"
            :with-actions="false"
            @submit="submit"
        >
            <template #filters>
                <div class="flex justify-end gap-2">
                    <Datepicker
                        v-model="filter.from"
                        class="w-36"
                    />

                    <Datepicker
                        v-model="filter.to"
                        class="w-36"
                    />
                </div>
            </template>

            <template #results>
                <tr v-for="date in dates" :key="date">
                    <td class="!w-0 whitespace-nowrap">{{ $date(date, 'll') }}</td>
                    <td class="!w-0 whitespace-nowrap capitalize">{{ $date(date, 'dddd') }}</td>
                    <td>
                        <span
                            v-text="$date(timeEntryForDate(date).checked_in_at, 'LTS')"
                            v-if="timeEntryForDate(date)?.checked_in_at"
                        />

                        <span
                            v-text="__('admin::labels.no_check_in')"
                            class="font-medium text-red-500"
                            v-else
                        />
                    </td>
                    <td>
                        <span
                            v-text="$date(timeEntryForDate(date).checked_out_at, 'LTS')"
                            v-if="timeEntryForDate(date)?.checked_out_at"
                        />

                        <span
                            v-text="__('admin::labels.no_check_out')"
                            class="font-medium text-red-500"
                            v-else
                        />
                    </td>
                    <td>{{ timeEntryForDate(date)?.work_time || '—'  }}</td>
                    <td class="!text-left">{{ timeEntryForDate(date)?.notes || '—' }}</td>
                </tr>
            </template>

        </Table>

    </IndexModelLayout>
</template>

<script>
export default {
    props: {
        request: Object,
        dates: Array,
        timeEntries: Array,
    },
    data() {
        return {
            filter: this.$inertia.form({
                from: this.request.from,
                to: this.request.to,
            }),
        };
    },
    methods: {
        submit() {
            this.filter.get(this.$route('admin::my-time-entries.index'));
        },
        timeEntryForDate(date) {
            return this.timeEntries.find(timeEntry => timeEntry.date === date);
        },
    }
}
</script>
